export const RESOLVE_STATE_LOADING_VIEW = "resolve-state-loading-view";
export const PRODUCTS_PAGE_PRODUCT_VIEW = "products-page-product-view";
export const SET_LOCATION_PAGE_LOCATION_VIEW = "set-location-page-location-view";
